import { getDemoKey, setDemoKey } from '@/services/demo'
import { useTranslations } from 'next-intl'
import { useState } from 'react'
import { useToast } from './use-toast'

const useTryDemo = ({ openInNewTab = true }) => {
  const [loading, setLoading] = useState(false)
  const { toast } = useToast()
  const t = useTranslations('Demo')

  const openDemo = (url: string) => {
    window.open(url, openInNewTab ? '_blank' : '_self')
  }

  async function onSubmit(source?: string) {
    setLoading(true)

    const key = await getDemoKey()

    if (key) {
      try {
        let response = await fetch('/api/get-demo/', {
          method: 'POST',
          body: JSON.stringify({ key }),
        })

        const data = (await response.json()) as { url: string; key: string }

        if (response.ok) {
          setDemoKey(data.key)
          openDemo(data.url)
          setLoading(false)
        } else {
          setLoading(false)
        }
      } catch (error) {
        setLoading(false)
      }
      return
    }

    try {
      let response = await fetch('/api/request/demo', {
        method: 'POST',
        body: JSON.stringify({
          source,
        }),
      })
      const data = (await response.json()) as { url: string; key: string }

      if (response.ok) {
        setDemoKey(data.key)
        openDemo(data.url)
        setLoading(false)
      } else {
        toast({
          title: t('request_fail_title'),
          description: t('request_fail_message'),
        })
        setLoading(false)
      }
    } catch (error) {
      setLoading(false)
    }
  }

  return {
    onSubmit,
    loading,
  }
}

export default useTryDemo
